export const rtfoConfig = {
  dataProviders: [
    'MRL', 
    'Coldbore', 
    'Peloton', 
    'Fracpro', 
    'Abra', 
    'Liberty', 
    'Corva',
    'Manual', 
    'Other'
  ],
  formations: [
    'Montney',
    'Duvernay',
    'Duvernay/Montney',
    'Cardium',
    'Velkerri B',
    'Eagle Ford',
    'Other'
  ],
  areas: [
    'Kakwa NW', 
    'Kakwa', 
    'Karr', 
    'Kaybob', 
    'Berland River', 
    'Valhalla', 
    'Cardium', 
    'Inga', 
    'Twining', 
    'Simonette', 
    'Carpentaria', 
    'Lator', 
    'Cygnet', 
    'Musreau', 
    'Mica',
    'Morningside',
    'Carrot Creek', 
    'Waskahigan',
    'Pembina',
    'Lacombe',
    'Huxley',
    'Chigwell',
    'Town',
    'Gundy Creek',
    'Wapiti',
    'Joffre',
    'Eagleville',
    'Other'
  ],
  clients: [
    'Whitecap', 
    'Yangarra', 
    'Artis Exploration', 
    'Yoho Resources', 
    'Kiwetinohk', 
    'Empire Energy', 
    'Vesta Energy', 
    'Baytex', 
    'Ovintiv', 
    'Vermilion Energy', 
    'Teine Energy', 
    'Paramount Resources', 
    'Petronas',
    'Marathon Oil',
    'Other'],
  monitorProviders: ['-', 'Bonnetts', 'Tronic', 'Coldbore', 'Abra', 'Critical Control', 'Revsolz', 'IWS'],
  seismicProviders: ['-', 'Spectraseis', 'Nanometrics']
};

export function getRTFOCompanyName(clientName) {
  if (clientName === 'wcap') {
    return 'Whitecap Resources';
  } else if (clientName === 'support') {
    return 'SSD';
  } else {
    return rtfoConfig?.clients?.find(c => c.toLowerCase().includes(clientName));
  };
};

export function stripMonitorUWI(uwi) {
  try {
    if (typeof uwi !== 'string') return '';

    return uwi.replace(/[^\d\w]/ig, '')?.substring(0, 7);
  } catch(error) {
    console.log(error);
    return uwi;
  };
};
  
export function getRTFOClientName(email) {
  try {
    return (
      isRTFOSuperUser(email) ? 'ssd' :
      (email?.toLowerCase()?.includes('@wcap') || email?.toLowerCase()?.includes('@whitecap.onmicrosoft.com') || email === 'tbailey99@gmail.com' || email === 'allan001@live.com' || email === 'tyler.labbe@hpstim.com' || email === 'bheppie@shaw.ca' || email === 'wcap@ssdynamics.com' || email === 'wcap_admin@ssdynamics.com') ? 'wcap' : 
      (email?.toLowerCase()?.includes('@yangarra') || email === 'yangarra@ssdynamics.com' || email === 'yangarra_admin@ssdynamics.com') ? 'yangarra' : 
      (email?.toLowerCase()?.includes('@yoho') || email === 'clive.mountford@outlook.com' || email === 'yoho@ssdynamics.com' || email === 'yoho_admin@ssdynamics.com') ? 'yoho' : 
      (email?.toLowerCase()?.includes('@artis') || email === 'artis@ssdynamics.com' || email === 'artis_admin@ssdynamics.com') ? 'artis' : 
      (email?.toLowerCase()?.includes('@kiwetinohk') || email === 'kiwetinohk@ssdynamics.com' || email === 'kiwetinohk_admin@ssdynamics.com') ? 'kiwetinohk' : 
      (email?.toLowerCase()?.includes('@empire') || email === 'empire@ssdynamics.com' || email === 'empire_admin@ssdynamics.com') ? 'empire' : 
      (email?.toLowerCase()?.includes('@vesta') || email === 'vesta@ssdynamics.com' || email === 'vesta_admin@ssdynamics.com') ? 'vesta' : 
      (email?.toLowerCase()?.includes('@baytex') || email === 'baytex@ssdynamics.com' || email === 'baytex_admin@ssdynamics.com') ? 'baytex' : 
      (email?.toLowerCase()?.includes('@ovintiv') || email === 'ovintiv@ssdynamics.com' || email === 'ovintiv_admin@ssdynamics.com') ? 'ovintiv' : 
      (email?.toLowerCase()?.includes('@vermilion') || email === 'mattbrooks1@gmail.com' || email === 'vermilion@ssdynamics.com' || email === 'vermilion_admin@ssdynamics.com') ? 'vermilion' : 
      (email?.toLowerCase()?.includes('@paramount') || email === 'paramount@ssdynamics.com' || email === 'paramount_admin@ssdynamics.com') ? 'paramount' : 
      (email?.toLowerCase()?.includes('@petronas') || email === 'petronas@ssdynamics.com' || email === 'petronas_admin@ssdynamics.com') ? 'petronas' : 
      (email?.toLowerCase()?.includes('@teine') || email === 'teine@ssdynamics.com' || email === 'teine_admin@ssdynamics.com') ? 'teine' : 
      (email?.toLowerCase()?.includes('@marathonoil') || email === 'marathon@ssdynamics.com' || email === 'marathon_admin@ssdynamics.com') ? 'marathon' : 
      (email === 'demo@ssdynamics.com' || email === 'demo_admin@ssdynamics.com') ? 'other' :
      (email === 'support@ssdynamics.com') ? 'support' : ''
    );
  } catch(error) {
    console.log(error);
    return 'other';
  };
};

export function isRTFOAdminUser(email) {
  try {
    return (email?.includes('admin@ssdynamics.com') || email === 'aborisov@ssdynamics.com') ? true : false;
  } catch(error) {
    console.log(error);
    return false;
  };
};

export function isRTFOSuperUser(email) { // has access to all client's pads
  try {
    return (
      email === 'aborisov@ssdynamics.com' ||
      email === 'dderyushkin@ssdynamics.com' ||
      email === 'jwilliamskovacs@ssdynamics.com' ||
      email === 'azhmodik@ssdynamics.com' ||
      email === 'asultanov@ssdynamics.com' ||
      email === 'bneil@ssdynamics.com' ||
      email === 'lfelipe@pigmacorp.com'
    ) ? true : false;
  } catch(error) {
    console.log(error);
    return false;
  };
};

